export default __webpack_public_path__ + "static/media/img-menu-editor-mobile.56ec9c70.png";